<template>
  <div class="card" v-show="currentCardId == 'job-image'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>画像PR</h2>
        <p>
          タイトル、使用ツール・言語、説明文、メイン画像を入力してください。<br />未入力の場合は空欄になります
        </p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <ImageItem
              v-for="(item, index) in imageList"
              :key="item.uuid"
              :item="item"
              :length="imageList.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeImageItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :activeImageItem="activeImageItem"
              :descriptionMaxLength="descriptionMaxLength"
              @click.native="activateImageItem(item.uuid)"
              @add-history-item="addImageItem"
              @delete-history-item="deleteImageItem"
              @move-history-item="moveImageItem"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              v-if="imageList.length < 2 || isYagiPrime"
              icon="el-icon-plus"
              circle
              type="success"
              @click="addImageItem()"
            />
            <el-button v-else circle type="success" @click="showPrimeUpsell">
              <span style="font-size: 1.5rem">🔒️</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ImageItem from '@/components/formats/ShokurekishoParts/ImageItem.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoImageItems } from '@/composables/format-edit/useShokurekishoImageItems'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
}>()

type FeatureHooks = {
  onSuccess: () => void
  onCancel: () => void
  onError?: () => void
}

const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const { vm, globalVar, yagiprimePaymentService, message } = useHostServices()
const {
  activeImageItem,
  addImageItem,
  deleteImageItem,
  moveImageItem,
  activateImageItem
} = useProvidedShokurekishoImageItems()

const isYagiPrime = computed(() => !!globalVar.isYagiPrime)
const imageList = computed(() => formatData.imageItems || [])

function showPrimeUpsell() {
  yagiprimePaymentService.useFeature(vm, 'shokurekisho-with-image-add-item', {
    onSuccess: () => {
      addImageItem()
      message({
        message: '成功しました',
        type: 'success'
      })
    },
    onCancel: () => {},
    onError: () => {
      message({
        message: '失敗しました',
        type: 'error'
      })
    }
  } as FeatureHooks)
}
</script>
